// extracted by mini-css-extract-plugin
export default {"formHeading":"dH-z","form":"eH-z","submitBtn":"fH-z","disabled":"gH-z","input":"hH-z","error":"iH-z","submitMsg":"jH-z","signIn":"kH-z"};